module.exports = __webpack_public_path__ + "uz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/uz.svg
// module id = 872
// module chunks = 0